module.exports = __webpack_public_path__ + "img/20180815_150347_083.82b60c62.jpg";